<style lang="stylus"></style>
<template>
    <div></div>
</template>

<i18n>
{
  "zh": {
    "bigger": "放大",
    "smaller": "缩小",
    "notes": "笔记",
    "image": "图形",
    "view": "浏览量",
    "like": "点赞",
    "collect": "收藏",
    "report": "举报",
    "share": "分享",
    "use": "使用此模板",
    "usedNums": "使用量",
    "cloneHint": {
      "memberFree": "会员免费",
      "free": "免费使用",
      "charge": "付费使用，需支付",
      "bought": "已购买，可直接使用"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "举报成功！",
      "reportOnce": "你已经举报过此作品",
      "cloning": "加载中..."
    },
    "reportInstruction": "为了保护您和被举报人的权利，请您慎重填写举报原因，我们会认真核实。",
    "reportReasonHint": "举报原因（5个字符以上）*",
    "validateWarn": {
      "reasonRequire": "举报原因不能为空！",
      "reasonLength": "举报原因不能少于5个字符且不能多于240个字符！"
    },
    "reportResonLabel": "举报理由",
    "reportTypeLabel": "举报类型",
    "reportType1": "违法违规：色情、暴力、血腥、敏感信息等",
    "reportType2": "盗用作品：侵犯原创作者的版权",
    "reportType3": "垃圾广告：广告推销",
    "reportType4": "其他理由",
    "noSpaceVip": "云空间已满",
    "previewMode": "预览模式",
    "noteMode": "笔记模式",
    "okText": "确定",
    "cancelText": "取消",
    "vip": "开通VIP会员",
    "vipFirstTip": "开通vip，立享首次使用模板免单福利！",
    "buynow": "直接购买",
    "clone": "使用模板",
    "cloneTip": "您已成为会员，可享受首次使用任意付费导图免单福利。",
    "newFile": "未命名文件",
    "fileSelectorTitle": "选择文件",
    "tip": "Edraw 提醒",
    "useSymbolTip": "当前版本不支持使用符号模板，升级更新至v11.5.0以上版本即可立即使用",
    "toUpgrade": "去升级"
  },
  "en": {
    "bigger": "Zoom in",
    "smaller": "Zoom out",
    "notes": "Notes",
    "image": "Image",
    "view": "Pageviews",
    "like": "Likes",
    "collect": "Favorites",
    "report": "Report",
    "share": "Share",
    "use": "Use immediately",
    "usedNums": "Usage amount",
    "cloneHint": {
      "memberFree": "Free for members",
      "free": "Free to Use",
      "charge": "Pay to Use",
      "bought": "Paid"
    },
    "currency": {
      "unit": "Dollar",
      "symbol": "$"
    },
    "message": {
      "reportSuccess": "Report successfully!",
      "reportOnce": "You have already reported this ",
      "cloning": "loading..."
    },
    "reportInstruction": "In order to protect the rights of you and the informant, please carefully fill in the reasons for reporting, we will carefully verify.",
    "reportReasonHint": "Report reason（Description should be at least 5 characters in length）*",
    "validateWarn": {
      "reasonRequire": "The report reason cannot be blank!",
      "reasonLength": "The reason for reporting cannot be less than 5 characters and no more than 240 characters!"
    },
    "reportResonLabel": "Reason",
    "reportTypeLabel": "Report type",
    "reportType1": "Violation of laws and regulations: pornography, violence, blood, sensitive information, etc.",
    "reportType2": "Misappropriation of works: infringement of the copyright of the original author",
    "reportType3": "Spam ads: advertising promotion",
    "reportType4": "Other reasons",
    "noSpaceVip": "The cloud storage is full.",
    "previewMode": "Preview mode",
    "noteMode": "Note mode",
    "okText": "OK",
    "cancelText": "Cancel",
    "vip": "Upgrade",
    "vipFirstTip": "Upgrade now and get a paid template for free.",
    "buynow": "Buy Now",
    "clone": "Use Template",
    "newFile": "Unnamed File",
    "cloneTip": "You are now a VIP member. Enjoy your first paid template for free",
    "fileSelectorTitle": "Select File",
    "tip": "Edraw tips",
    "useSymbolTip": "The current version does not support the Symbols Templates function. Please update to V11.5 or later versions to use it.",
    "toUpgrade": "Update Now"
  },
  "de": {
    "bigger": "Zoom in",
    "smaller": "Zoom out",
    "notes": "Notiz",
    "image": "Bild",
    "view": "Ansichten",
    "like": "Likes",
    "collect": "Favoriten",
    "report": "Bericht",
    "share": "Teilen",
    "use": "Diese Vorlage verwenden",
    "usedNums": "Nutzungsmenge",
    "cloneHint": {
      "memberFree": "Kostenlos für Mitglieder",
      "free": "Kostenlos zu benutzen",
      "charge": "Verwendung bezahlen",
      "bought": "Bezahlt"
    },
    "currency": {
      "unit": "RMB",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "Erfolgreich gemeldet!",
      "reportOnce": "Sie haben diese Arbeit bereits gemeldet",
      "cloning": "Wird geladen..."
    },
    "reportInstruction": "Um die Rechte von Ihnen und dem Informanten zu schützen, geben Sie bitte die Gründe für die Meldung sorgfältig an. Wir werden dies sorgfältig überprüfen.",
    "reportReasonHint": "Grund melden （Beschreibung sollte mindestens 5 Zeichen lang sein） *",
    "validateWarn": {
      "reasonRequire": "Der Berichtsgrund darf nicht leer sein!",
      "reasonLength": "Der Grund für die Meldung darf nicht weniger als 5 Zeichen und nicht mehr als 240 Zeichen betragen!"
    },
    "reportResonLabel": "Meldungsgrund",
    "reportTypeLabel": "Meldungstyp",
    "reportType1": "Verstöße gegen Gesetze und Vorschriften: Pornografie, Gewalt, Blut, sensible Informationen usw. ",
    "reportType2": "Veruntreuung von Werken: Verletzung des Urheberrechts des ursprünglichen Autors",
    "reportType3": "Spam-Anzeigen: Werbung",
    "reportType4": "Andere Gründe",
    "noSpaceVip": "Keinen Cloud-Speicherplatz",
    "previewMode": "Vorbild Modus",
    "noteMode": "Notiz-Modus",
    "okText": "Sichern",
    "cancelText": "Abbrechen",
    "newFile": "Unbenannte Datei",
    "fileSelectorTitle": "Wählen Sie ein Dokument aus",
    "tip": "Edraw Tipps",
    "useSymbolTip": "Die aktuelle Version unterstützt die Funktion Symbolvorlagen nicht. Bitte aktualisieren Sie auf V11.5 oder neuere Versionen, um es zu verwenden.",
    "toUpgrade": "Jetzt Aktualisieren"
  },
  "fr": {
    "bigger": "Zoom avant",
    "smaller": "Zoom arrière",
    "notes": "Notes",
    "image": "Graphique",
    "view": "Pages vues",
    "like": "Aimes",
    "collect": "Favoris",
    "report": "Rapport",
    "share": "Partager",
    "use": "Utilisez ce modèle",
    "usedNums": "Montant d'utilisation",
    "cloneHint": {
      "memberFree": "Gratuit pour les membres",
      "free": "Utilisation gratuite",
      "charge": "Payer pour utiliser",
      "bought": "Paid"
    },
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "message": {
      "reportSuccess": "Rapporté avec succès!",
      "reportOnce": "Vous avez déjà signalé ce travail.",
      "cloning": "chargement..."
    },
    "reportInstruction": "Afin de protéger vos droits et ceux de l'informateur, veuillez indiquer soigneusement les raisons du signalement, nous vérifierons soigneusement.",
    "reportReasonHint": "Raison du rapport (la description doit comporter au moins 5 caractères) *",
    "validateWarn": {
      "reasonRequire": "La raison du rapport ne peut pas être vide!",
      "reasonLength": "La raison du signalement ne peut pas être inférieure à 5 caractères et pas plus de 240 caractères!"
    },
    "reportResonLabel": "Raison du signalement",
    "reportTypeLabel": "Type de rapport",
    "reportType1": "Violation des lois et règlements: pornographie, violence, sang, informations sensibles, etc.",
    "reportType2": "Détournement d'œuvres: violation du droit d'auteur de l'auteur original",
    "reportType3": "Annonces de spam: promotion publicitaire",
    "reportType4": "Autres raisons",
    "noSpaceVip": "L'espace nuage est plein",
    "previewMode": "Mode aperçu",
    "noteMode": "Mode note",
    "okText": "Créer",
    "newFile": "Fichier sans nom",
    "cancelText": "Annuler",
    "fileSelectorTitle": "Sélectionnez un document",
    "tip": "Rappel Edraw",
    "useSymbolTip": "La version actuelle ne prend pas en charge la fonction Modèles de symboles. Veuillez mettre à jour vers la V11.5 ou les versions ultérieures pour l'utiliser.",
    "toUpgrade": "Mettez à jour"
  },
  "es": {
    "bigger": "Acercar",
    "smaller": "Alejar",
    "notes": "Notas",
    "image": "Gráfico",
    "view": "Páginas vistas",
    "like": "Likes",
    "collect": "Favoritos",
    "report": "Reportar",
    "share": "Compartir",
    "use": "Usa esta plantilla",
    "usedNums": "Cantidad de uso",
    "cloneHint": {
      "memberFree": "Gratis para miembros",
      "free": "Gratis",
      "charge": "Pagos",
      "bought": "Pagados"
    },
    "currency": {
      "unit": "Yuan",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "¡Reportado exitosamente!",
      "reportOnce": "Ya has reportado de este trabajo",
      "cloning": "cargando..."
    },
    "reportInstruction": "Con el fin de proteger los derechos de usted y del informante, por favor complete cuidadosamente las razones para informar, lo verificaremos cuidadosamente.",
    "reportReasonHint": "Motivo del reporte （La descripción debe tener al menos 5 caracteres de longitud） *",
    "validateWarn": {
      "reasonRequire": "¡El motivo del reporte no puede estar en blanco!",
      "reasonLength": "¡El motivo de la denuncia no puede tener menos de 5 caracteres ni más de 240 caracteres!"
    },
    "reportResonLabel": "Razón del reporte ",
    "reportTypeLabel": "Tipo de reporte ",
    "reportType1": "Violaciones y Sanciones: pornografía, violencia, sangre, información sensible, etc.",
    "reportType2": "Apropiación indebida de obras: infracción de los derechos de autor del autor original",
    "reportType3": "Anuncios de spam: promoción publicitaria",
    "reportType4": "Otras razones",
    "noSpaceVip": "El espacio en la nube está lleno",
    "previewMode": "Modo de vista previa",
    "noteMode": "Modo de nota",
    "okText": "Confirmar",
    "newFile": "Archivo sin nombre",
    "cancelText": "Cancelar",
    "fileSelectorTitle": "Seleccionar un documento",
    "tip": "Consejos de Edraw",
    "useSymbolTip": "La versión actual no admite la función Plantillas de símbolos. Actualice a V11.5 o posterior para usarlo.",
    "toUpgrade": "Actualizar"
  },
  "jp": {
    "bigger": "ズームイン",
    "smaller": "ズームアウト",
    "notes": "注釈",
    "image": "图形",
    "view": "ページビュー",
    "like": "いいね",
    "collect": "お気に入り",
    "report": "報告",
    "share": "共有",
    "use": "このテンプレートを使用する",
    "usedNums": "使用回数",
    "cloneHint": {
      "memberFree": "会員無料",
      "free": "無料機能",
      "charge": "有料機能",
      "bought": "購入済み"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "正常に報告しました。",
      "reportOnce": "この作品はすでに報告されました。",
      "cloning": "読み込み中..."
    },
    "reportInstruction": "報告者と報告される方の権利を保護するため、報告理由を慎重に記入してください。",
    "reportReasonHint": "報告理由（5文字以上）*",
    "validateWarn": {
      "reasonRequire": "報告理由を記入してください。",
      "reasonLength": "報告する理由は、5文字以上240文字以下にする必要があります。"
    },
    "reportResonLabel": "報告理由",
    "reportTypeLabel": "報告タイプ",
    "reportType1": "法律違反：ポルノ、暴力、血、機密情報など",
    "reportType2": "著作物の無断使用：著作権侵害",
    "reportType3": "スパム広告：広告宣伝",
    "reportType4": "その他",
    "noSpaceVip": "クラウドストレージがいっぱいです",
    "previewMode": "预览模式",
    "noteMode": "笔记模式",
    "okText": "確認",
    "newFile": "名前のないファイル",
    "cancelText": "キャンセル",
    "fileSelectorTitle": "ファイル選択",
    "tip": "Edrawからのご注意",
    "useSymbolTip": "現在のバージョンでは、「記号のテンプレート機能」に対応していません。V11.5以降のバージョンにアップデートしてください。",
    "toUpgrade": "今すぐアップデート"
  },
  "pt": {
    "bigger": "Prolongar",
    "smaller": "Encolher",
    "notes": "Notas",
    "image": "Gráficos",
    "view": "Visualizações de página",
    "like": "Gosto",
    "collect": "Coletar",
    "report": "Reportar",
    "share": "Compartihar",
    "use": "Usar este modelo",
    "usedNums": "Quantidade de uso",
    "cloneHint": {
      "memberFree": "Grátis para membros",
      "free": "Livre para usar",
      "charge": "Uso pago, precisar de pagar",
      "bought": "Foi comprado e pode ser usado diretamente"
    },
    "currency": {
      "unit": "yuan",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "Reportar com sucesso!",
      "reportOnce": "Você já reportou este trabalho",
      "cloning": "Carregando..."
    },
    "reportInstruction": "Para proteger os seus direitos e os do informante, preencha cuidadosamente os motivos da denúncia, que iremos verificar cuidadosamente.",
    "reportReasonHint": "Motivo da reporta (a descrição deve ter pelo menos 5 caracteres)*",
    "validateWarn": {
      "reasonRequire": "O motivo da reporta não pode ficar em branco!",
      "reasonLength": "O motivo da denúncia não pode ter menos de 5 caracteres e não mais de 240 caracteres!"
    },
    "reportResonLabel": "Razão da reporta",
    "reportTypeLabel": "Tipo da reporta",
    "reportType1": "Violação de leis e regulamentos: pornografia, violência, sangue, informações confidenciais, etc.",
    "reportType2": "Apropriação indébita de obras: violação dos direitos autorais do autor original",
    "reportType3": "Anúncios de spam: promoção de publicidade",
    "reportType4": "Outras razões",
    "noSpaceVip": "O espaço da nuvem está cheio",
    "previewMode": "Modo de pré-visualização",
    "noteMode": "Modo de nota",
    "okText": "OK",
    "newFile": "Ficheiro Sem Nome",
    "cancelText": "Cancelar",
    "fileSelectorTitle": "Selecione um documento",
    "tip": "Dicas Edraw",
    "useSymbolTip": "A versão atual não suporta a função de Modelos de Símbolos. Por favor atualize para V11.5 ou versões posteriores para usá-lo.",
    "toUpgrade": "Atualize Agora"
  },
  "it": {
    "bigger": "Ingrandire",
    "smaller": "Riduci lo zoom",
    "notes": "Appunti",
    "image": "Grafico",
    "view": "Visualizzazioni di pagina",
    "like": "Piace",
    "collect": "Preferiti",
    "report": "Rapporto",
    "share": "Condivide",
    "use": "Usa questo modello",
    "usedNums": "Quantità di utilizzo",
    "cloneHint": {
      "memberFree": "Gratuito per i membri",
      "free": "L'uso gratuito",
      "charge": "Paga per l'uso",
      "bought": "Pagato"
    },
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "message": {
      "reportSuccess": "Segnalato con successo!",
      "reportOnce": "Hai già segnalato questo lavoro.",
      "cloning": "Caricamento in corso..."
    },
    "reportInstruction": "Al fine di tutelare i tuoi diritti e quelli dell'informatore, ti preghiamo di indicare attentamente i motivi della segnalazione, che controlleremo attentamente.",
    "reportReasonHint": "Motivo della segnalazione (la descrizione deve contenere almeno 5 caratteri)*",
    "validateWarn": {
      "reasonRequire": "Il motivo del rapporto non può essere vuoto！",
      "reasonLength": "Il motivo della segnalazione non può essere inferiore a 5 caratteri e non superiore a 240 caratteri!"
    },
    "reportResonLabel": "Motivo della relazione",
    "reportTypeLabel": "Tipo di rapporto",
    "reportType1": "Violazione di leggi e regolamenti: pornografia, violenza, sangue, informazioni sensibili, ecc.",
    "reportType2": "Appropriazione indebita di opere: violazione del copyright dell'autore originale",
    "reportType3": "Annunci spam: promozione pubblicitaria",
    "reportType4": "Altri motivi",
    "noSpaceVip": "Lo spazio cloud è pieno",
    "previewMode": "Modalità anteprima",
    "noteMode": "Modalità nota",
    "okText": "OK",
    "newFile": "File Senza Nome",
    "cancelText": "Annulla",
    "fileSelectorTitle": "Seleziona un documento",
    "tip": "Suggerimenti di Edraw",
    "useSymbolTip": "La versione corrente non supporta la funzione Modelli di Simboli. Si prega di aggiornare a V11.5 o versioni successive per usarlo.",
    "toUpgrade": "Aggiorna Ora"
  },
  "tw": {
    "bigger": "放大",
    "smaller": "縮小",
    "notes": "筆記",
    "image": "圖形",
    "view": "瀏覽量",
    "like": "點讚",
    "collect": "收藏",
    "report": "舉報",
    "share": "分享",
    "use": "使用此模板",
    "usedNums": "使用量",
    "cloneHint": {
      "memberFree": "會員免費",
      "free": "免費使用",
      "charge": "付費使用，需支付",
      "bought": "已購買，可直接使用"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "舉報成功！",
      "reportOnce": "你已經舉報過此產品",
      "cloning": "加載中..."
    },
    "reportInstruction": "為了保護您和被舉報人的權利，請您謹慎填寫舉報原因，我們會認真核實。",
    "reportReasonHint": "舉報原因（5個字符以上）*",
    "validateWarn": {
      "reasonRequire": "舉報原因不能為空！",
      "reasonLength": "舉報原因不能少於5個字符且不能多於240個字符！"
    },
    "reportResonLabel": "舉報理由",
    "reportTypeLabel": "舉報類型",
    "reportType1": "違法違規：色情、暴力、血腥、敏感信息等",
    "reportType2": "盜用作品：侵犯原創作者的版權",
    "reportType3": "垃圾廣告：廣告推銷",
    "reportType4": "其他理由",
    "noSpaceVip": "雲端硬碟已滿",
    "previewMode": "預覽模式",
    "noteMode": "筆記模式",
    "okText": "確定",
    "newFile": "未命名檔案",
    "cancelText": "取消",
    "fileSelectorTitle": "選擇文件",
    "tip": "Edraw 提醒",
    "useSymbolTip": "當前版本不支持使用符號模板，升級更新至V11.5.0以上版本立即使用",
    "toUpgrade": "去升級"
  },
  "kr": {
    "bigger": "확대",
    "smaller": "축소",
    "notes": "노트",
    "image": "이미지",
    "view": "조회수",
    "like": "좋아요",
    "collect": "즐겨찾기",
    "report": "신고",
    "share": "공유",
    "use": "템플릿 적용하기",
    "usedNums": "적용 횟수",
    "cloneHint": {
      "memberFree": "회원 무료",
      "free": "무료 사용",
      "charge": "유료 사용",
      "bought": "구매 완료, 바로 사용 가능"
    },
    "currency": {
      "unit": "원",
      "symbol": "₩"
    },
    "message": {
      "reportSuccess": "신고 성공!",
      "reportOnce": "이미 신고하셨습니다!",
      "cloning": "로딩중..."
    },
    "reportInstruction": "귀하와 피신고자의 권리를 보호하기 위해 신고 사유를 신중히 기입해 주시면 꼼꼼하게 확인하겠습니다.",
    "reportReasonHint": "신고 이유（5자 이상）*",
    "validateWarn": {
      "reasonRequire": "신고 이유를 비워둘 수 없습니다.",
      "reasonLength": "신고 이유는 5 자 이상 240 자 이하여야 합니다!"
    },
    "reportResonLabel": "신고 이유",
    "reportTypeLabel": "신고 유형",
    "reportType1": "법률 및 규정 위반 : 포르노, 폭력, 혈성, 민감 정보 등",
    "reportType2": "저작물의 도용 : 원저작자의 저작권 침해",
    "reportType3": "스팸 : 광고 ",
    "reportType4": "기타 이유",
    "noSpaceVip": "클라우드 공간이 부족합니다.",
    "previewMode": "미리 보기 모드",
    "noteMode": "노트모드",
    "okText": "확인",
    "cancelText": "취소",
    "vip": "VIP 회원을 개설합니다",
    "vipFirstTip": "VIP 개통, 첫 번째 템플릿 사용 무료 혜택을 받아보세요!",
    "buynow": "지금 구매",
    "clone": "템플릿 사용",
    "cloneTip": "당신은 이제 VIP 회원이 되었습니다. 첫 번째 유료 템플릿을 무료로 즐기십시오.",
    "newFile": "이름 없는 파일",
    "fileSelectorTitle": "문서 선택",
    "tip": "Edraw 팁",
    "useSymbolTip": "현재 버전은 기호 템플릿 기능을 지원하지 않습니다. V11.5.0버전 이상으로 업그레이드하면 사용할 수 있습니다.",
    "toUpgrade": "업그레이드하기"
  },
  "id": {
    "bigger": "Perbesar",
    "smaller": "Perkecil",
    "notes": "Catatan",
    "image": "Gambar",
    "view": "Tampilan Halaman",
    "like": "Suka",
    "collect": "Favorit",
    "report": "Laporkan",
    "share": "Bagikan",
    "use": "Gunakan segera",
    "usedNums": "Jumlah penggunaan",
    "cloneHint": {
      "memberFree": "Gratis untuk anggota",
      "free": "Penggunaan Gratis",
      "charge": "Penggunaan Berbayar",
      "bought": "Berbayar"
    },
    "currency": {
      "unit": "Dolar",
      "symbol": "$"
    },
    "message": {
      "reportSuccess": "Laporan berhasil!",
      "reportOnce": "Anda telah melaporkan hal ini ",
      "cloning": "memuat ...."
    },
    "reportInstruction": "Untuk melindungi hak Anda dan informan, isi alasan pelaporan dengan teliti, kami akan memverifikasi dengan cermat.",
    "reportReasonHint": "Alasan laporan（Deskripsi harus berisi setidaknya 5 karakter）*",
    "validateWarn": {
      "reasonRequire": "Alasan laporan tidak boleh kosong!",
      "reasonLength": "Alasan pelaporan tidak boleh kurang dari 5 karakter dan tidak lebih dari 240 karakter!"
    },
    "reportResonLabel": "Alasan",
    "reportTypeLabel": "Jenis laporan",
    "reportType1": "Pelanggaran terhadap undang-undang dan peraturan: pornografi, kekerasan, darah, informasi sensitif, dsb.",
    "reportType2": "Penyalahgunaan karya: pelanggaran hak cipta penulis asli",
    "reportType3": "Iklan spam: Promosi iklan",
    "reportType4": "Alasan lain",
    "noSpaceVip": "Penyimpanan cloud penuh.",
    "previewMode": "Mode pratinjau",
    "noteMode": "Mode catatan",
    "okText": "OKE",
    "cancelText": "Batalkan",
    "vip": "Tingkatkan",
    "vipFirstTip": "Tingkatkan sekarang dan dapatkan templat berbayar gratis.",
    "buynow": "Beli Sekarang",
    "clone": "Gunakan Templat",
    "newFile": "File Tanpa Nama",
    "cloneTip": "Anda sekarang menjadi anggota VIP. Nikmati templat berbayar pertama Anda secara gratis",
    "fileSelectorTitle": "Pilih File",
    "tip": "Tip Edraw",
    "useSymbolTip": "Versi saat ini tidak mendukung fungsi Templat Simbol. Perbarui ke V11.5 atau versi yang lebih baru untuk menggunakannya.",
    "toUpgrade": "Perbarui Sekarang"
  }
}
</i18n>

<script>
    import { EDRAWMAX_PRODUCT_VIPLIMIT, EDRAWMAX_USE_CREDIT } from "@/env/";
    import get from "lodash/get";
    import appConfig from "@/public/globalConfig";
    import { adonlineURL } from "@/public/utils/tool.js";
    export default {
        name: "TplPreview",
        components: {},
        data() {
            return {
                loading: true,

                cloneVipTips: true,

                // vipfirst
                vipFirstFlag: false,
                showVipFirstTip: false, // 是否享受过首单免费
                pcBuyFlag: false, // 是否唤起pc登录窗口，vip状态改变时刷新首单免费状态
                pcFreeTemplateFlag: false, // 记录非会员模板是否有免费模板次数

                pass: true,
            };
        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo;
            },
            work() {
                return this.$store.state.tplCenter.activeWork;
            },
            boughtWorks() {
                return this.$store.state.tplCenter.boughtWorks;
            },
            //是否购买过
            hasBought() {
                return this.boughtWorkIds.includes(this.work.id);
            },
            boughtWorkIds() {
                let ids = [];
                this.boughtWorks &&
                    this.boughtWorks.forEach((item) => {
                        ids.push(item.work_id);
                    });
                return ids;
            },
            isSymbol() {
                // 是否是符号模板
                return this.work.type == "edt";
            },
            pcLogin() {
                return get(this.userInfo, "user_id", "") || "";
            },
            limitFileNum() {
                return this.$store.state.limitFileNum || 3;
            },
            hasCreditMoney() {
                return this.$store.state.hasCreditMoney;
            },
        },
        watch: {
            vip(v) {
                if (this.pcBuyFlag && v) {
                    this.pcBuyFlag = false;
                    this.checkFirstVip();
                }
            },
            pcLogin(val, oldval) {
                if (val && this.isPC) {
                    let cloneVipTips = JSON.parse(localStorage.getItem("cloneVipTips"));
                    this.cloneVipTips = !(cloneVipTips && cloneVipTips.includes(this.userInfo.user_id));
                    console.log("cloneVipTips---", this.cloneVipTips);
                    this.checkFirstVip();
                }
            },
        },
        methods: {
            // 添加最近记录
            addTemplateRecent(id) {
                if (!this.$validateLogin()) return;
                this.$edApi
                    .addTemplateHistory({
                        user_id: this.userInfo.user_id,
                        token: this.userInfo.token,
                        data: {
                            template_id: id,
                            template_from: "COMMUNITY",
                        },
                    })
                    .then((e) => {
                        console.log("add subclass recent", e);
                        // this.initRecentData();
                    });
            },
            //克隆
            toVip() {
                if (this.isPC) {
                    this.pcBuyFlag = true;
                    this.userInfo.islogin &&
                        window.$qt.jsCallUpdateUpgradeTrigger &&
                        window.$qt.jsCallUpdateUpgradeTrigger("pay template in community");
                }
                let tType = this.work.member_free ? "cummunityVipTemplate" : "cummunityPayTemplates";
                this.$openBuyPage(tType);
            },
            firstCloneFreeToVip() {
                const suffix = "iscommunity=1";
                if (this.isPC) {
                    this.pcBuyFlag = true;
                    this.userInfo.islogin &&
                        window.$qt.jsCallUpdateUpgradeTrigger &&
                        window.$qt.jsCallUpdateUpgradeTrigger("pay template in community");
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "upgradeSuffix",
                        data: "iscommunity=1",
                    });
                }
                let tType = this.work.member_free ? "cummunityVipTemplate" : "cummunityPayTemplates";
                this.$openBuyPage(tType, suffix);
            },
            firstCloneFree() {
                let flag = false;
                if (this.vipFirstFlag && this.work.price != 0 && !this.work.member_free) {
                    this.$bus.$emit("firstCloneFreeBusToStore", 1);
                    // this.$Modal.info({
                    //     title: this.$t('clone'),
                    //     content: this.$t('cloneTip'),
                    //     onOk: () => {
                    //         this.cloneWorkWithFirstVip();
                    //     }
                    // });
                    flag = true;
                }
                if (
                    !this.vip &&
                    this.showVipFirstTip &&
                    this.cloneVipTips &&
                    this.work.price != 0 &&
                    !this.work.member_free &&
                    this.boughtWorkIds.indexOf(this.work.id) == -1
                ) {
                    let cloneVipTips = JSON.parse(localStorage.getItem("cloneVipTips"));
                    if (cloneVipTips) {
                        cloneVipTips.push(this.userInfo.user_id);
                        localStorage.setItem("cloneVipTips", JSON.stringify(cloneVipTips));
                    } else {
                        localStorage.setItem("cloneVipTips", "[]");
                    }
                    this.cloneVipTips = false;
                    this.$bus.$emit("firstCloneFreeBusToStore", 0);
                    // this.$Modal.confirm({
                    //     title: this.$t('vip'),
                    //     content: this.$t('vipFirstTip'),
                    //     cancelText: this.$t('buynow'),
                    //     okText: this.$t('vip'),
                    //     onOk: () => {
                    //        this.toVip()
                    //     },
                    //     onCancel: () => {
                    //         this.clone()
                    //     }
                    // });
                    flag = true;
                }
                return flag;
            },
            async clone() {
                this.pass = true;
                if (this.isPlugin) {
                    location.href = `${window.location.origin}${appConfig["sourcePath"]}app.html?plugin=board&useTemplate=1&tid=${this.work.id}`;
                    return;
                }
                if (!this.internal && this.userInfo) {
                    const params = {
                        work_id: this.work.id,
                        token: this.userInfo.token,
                    };
                    const pass = await this.$edApi.workCloneCheck(this.userInfo.user_id, params);
                    this.pass = pass;
                    if (this.isPC && (!this.$isBiggerVersion("13.5.0") || this.platform != "win")) {
                        const isAd = [5517, 5518].includes(this.pid);
                        if (!pass) {
                            let url = !this.vip
                                ? "https://www.edrawsoft.com/pricing-edrawmax.html"
                                : "https://www.edrawsoft.com/store/effects-buy.html";
                            if ([5517, 5518].includes(this.pid)) {
                                url = !this.vip
                                    ? "https://www.edrawsoft.com/ad/pricing-edrawmax.html"
                                    : "https://www.edrawsoft.com/ad/store/edrawmax-effects-buy.html";
                            }
                            window.$qt.jsCallOpenUrl(url);
                            return;
                        }
                    }
                    // const isAd = [5517, 5518].includes(this.pid);
                    // if (!pass) {
                    //     let url = !this.vip ? "https://www.edrawsoft.com/pricing-edrawmax.html" : "https://www.edrawsoft.com/store/effects-buy.html";
                    //     if ([5517, 5518].includes(this.pid)) {
                    //         url = !this.vip
                    //             ? "https://www.edrawsoft.com/ad/pricing-edrawmax.html"
                    //             : "https://www.edrawsoft.com/ad/store/edrawmax-effects-buy.html";
                    //     }
                    //     if (this.isPC) {
                    //         window.$qt.jsCallOpenUrl(url);
                    //     } else {
                    //         window.open(url);
                    //     }
                    //     return;
                    // }
                }
                if (this.isSymbol) {
                    this.cloneSymbol();
                    return;
                }

                if (this.isPC) {
                    this.clonePC();
                    return;
                }

                if (!this.$validateLogin()) return;

                this.trackData("useTemplate");

                // 检验是否能使用首单免费
                let isFirstFree = false;
                if (this.internal) {
                    isFirstFree = this.firstCloneFree();
                }
                if (isFirstFree) return;

                if (this.work.user_id == this.userInfo.user_id) {
                    this.cloneFunc();
                    return;
                }
                if (this.work.allow_copy && this.work.price > 0 && this.boughtWorkIds.indexOf(this.work.id) == -1) {
                    //收费并且未购买，显示收费窗口
                    // 首先检验是否需要弹出非会员创建限制弹窗
                    let limitFunc = (type = "") => {
                        if (type == "showLimitModal") {
                            this.$bus.$on("limitModalContinue", () => {
                                console.log("on event");
                                this.$bus.$off("limitModalContinue");
                                this.clone();
                            });
                            this.$store.commit("setState", {
                                type: "showLimitFileModal",
                                data: true,
                            });
                        } else if (type == "showLimitCloudSpaceVIP") {
                            if (this.fuser) {
                                this.$bus.$emit("showCloudSpaceVipTips");
                            } else {
                                this.$checkAuth({
                                    type: "cloudSpaceVIP",
                                    buyTrigger: "cloudSpacePop",
                                    pcParams: { newUpgrade: 6, upgrade: 0 },
                                });
                            }
                        } else if (type == "showLimitCloudSpace") {
                            this.$checkAuth({
                                type: "cloudSpace",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        }
                    };
                    this.$openFile({
                        params: "",
                        fileType: "checkLimit",
                        suffix: "",
                        checkLimit: true,
                        limitRange: this.$store.state.publicStore.runPlatform,
                        limitCallback: limitFunc,
                        vip: this.vip,
                        isFullCouldSpace: this.isFullCouldSpace,
                    }).then(() => {
                        if (EDRAWMAX_USE_CREDIT && this.toCredit()) {
                            return;
                        }
                        // 克隆步骤于pay弹窗完成
                        this.$bus.$emit("updatePayPanelStatus", {
                            showPay: true,
                            cloneSucess: false,
                            clonedObj: "",
                        });
                        this.trackData("remindPaid");
                    });
                }
                // else if (this.work.member_free && !this.$checkAuth({ type: "cmfree" })) {
                //     //会员免费，并且用户不是会员，显示购买会员界面
                //     this.trackData('alertVipModal');
                //     return;
                // }
                else {
                    this.cloneFunc();
                }
            },
            clonePC() {
                this.trackDataPC("useTemplate");
                if (this.work.member_free && this.userInfo.islogin) {
                    this.trackDataPC("useVipTemplate");
                }
                if (!this.userInfo.islogin) {
                    this.trackDataPC("usePaidTemplate");
                    if (this.work.member_free) {
                        if (window.$qt.jsCallOpenVipTemplateWithoutLogin) {
                            window.$qt.jsCallOpenVipTemplateWithoutLogin(JSON.stringify(this.work));
                        } else {
                            window.$qt.jsCallNewUpgradeToPremium && window.$qt.jsCallNewUpgradeToPremium(4);
                        }
                        window.$qt.jsCallUpgradeToPremium && window.$qt.jsCallUpgradeToPremium(1);
                    } else {
                        window.$qt.jsCallUserLogin();
                    }
                    return;
                }

                // 检验是否能使用首单免费
                let isFirstFree = false;
                if (this.internal) {
                    isFirstFree = this.firstCloneFree();
                }
                if (isFirstFree) return;

                if (this.work.user_id == this.userInfo.user_id) {
                    this.cloneFuncPC();
                    return;
                }
                if (this.work.type != "edt" && this.work.allow_copy && this.work.price > 0 && this.boughtWorkIds.indexOf(this.work.id) == -1) {
                    //收费并且未购买，显示收费窗口
                    // 首先检验是否需要弹出非会员创建限制弹窗
                    let limitFunc = (type = "") => {
                        if (type == "showLimitModal") {
                            this.$bus.$on("limitModalContinue", () => {
                                console.log("on event");
                                this.$bus.$off("limitModalContinue");
                                this.clone();
                            });
                            this.$store.commit("setState", {
                                type: "showLimitFileModal",
                                data: true,
                            });
                        } else if (type == "showLimitCloudSpaceVIP") {
                            if (this.fuser) {
                                this.$bus.$emit("showCloudSpaceVipTips");
                            } else {
                                this.$checkAuth({
                                    type: "cloudSpaceVIP",
                                    buyTrigger: "cloudSpacePop",
                                    pcParams: { newUpgrade: 6, upgrade: 0 },
                                });
                            }
                        } else if (type == "showLimitCloudSpace") {
                            this.$checkAuth({
                                type: "cloudSpace",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        }
                    };
                    this.$openFile({
                        params: "",
                        fileType: "checkLimit",
                        suffix: "",
                        checkLimit: true,
                        limitRange: this.$store.state.publicStore.runPlatform,
                        limitCallback: limitFunc,
                        vip: this.vip,
                        isFullCouldSpace: this.isFullCouldSpace,
                    }).then(() => {
                        if (EDRAWMAX_USE_CREDIT && this.toCredit()) {
                            return;
                        }
                        // 克隆步骤于pay弹窗完成
                        this.$bus.$emit("updatePayPanelStatus", {
                            showPay: true,
                            cloneSucess: false,
                            clonedObj: "",
                        });
                        this.trackDataPC("remindPaid");
                    });
                } else {
                    this.cloneFuncPC();
                }
            },

            cloneFunc() {
                if (this.doingClone) return;
                this.$edMessage.loading({
                    duration: 0,
                    content: this.$t("message.cloning"),
                });
                this.doingClone = true;
                let id = this.params.id,
                    token = this.params.token,
                    workId = this.work.id;

                // 跳过立即使用直接打开
                let newTab;
                if (!this.openInTabs) {
                    newTab = window.open(`${window.location.origin}${this.$router.options.base}app.html`, "");
                }

                let limitCallback = (type = "") => {
                    newTab && newTab.close();
                    this.doingClone = false;
                    this.trackData("remindSubscribe");
                    this.$edMessage.destroy();
                    if (type == "showLimitModal") {
                        this.$bus.$on("limitModalContinue", () => {
                            console.log("on event");
                            this.$bus.$off("limitModalContinue");
                            this.cloneFunc();
                        });
                        this.$store.commit("setState", {
                            type: "showLimitFileModal",
                            data: true,
                        });
                    } else if (type == "limitVipTemplate") {
                        this.trackData("alertVipModal");
                        this.$openBuyPage("cummunityVipTemplate");
                    } else if (type == "showLimitCloudSpaceVIP") {
                        if (this.fuser) {
                            this.$bus.$emit("showCloudSpaceVipTips");
                        } else {
                            this.$checkAuth({
                                type: "cloudSpaceVIP",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        }
                    } else if (type == "showLimitCloudSpace") {
                        this.$checkAuth({
                            type: "cloudSpace",
                            buyTrigger: "cloudSpacePop",
                            pcParams: { newUpgrade: 6, upgrade: 0 },
                        });
                    } else {
                        this.$store.commit("toPublicStatus", {
                            type: "showUpgrade",
                            data: "fileNum",
                        });
                    }
                };
                let tType = this.work.price > 0 ? "communityPaid" : this.work.member_free ? "communityVip" : "communityFree";
                let enterCanvasTrack = `&file_source=templateFile&template_type=${tType}&diagram_type=others`;
                let trackSuffix = this.isAd ? `&from=ad` : "";
                trackSuffix += enterCanvasTrack;
                if (!this.pass || (this.internal && this.work.member_free)) {
                    trackSuffix += `&cummunityVipTemplate=1`;
                }
                this.$openFile({
                    params: {
                        id,
                        workId,
                        token,
                        member: this.work.member_free,
                        type: "online",
                        platform: this.$store.state.publicStore.runPlatform,
                    },
                    fileType: "storeTemplate",
                    suffix: trackSuffix,
                    checkLimit: true,
                    limitRange: this.$store.state.publicStore.runPlatform,
                    limitCallback: limitCallback,
                    vip: this.vip,
                    isFullCouldSpace: this.isFullCouldSpace,
                })
                    .then((obj) => {
                        this.addTemplateRecent(workId);
                        this.trackData("cloneSuccess");
                        let url = adonlineURL(obj.url);
                        if (this.openInTabs) {
                            location.href = url;
                        }
                        try {
                            newTab.location.href = url;
                        } catch (error) {
                            newTab && newTab.close();
                            this.$bus.$emit("updatePayPanelStatus", {
                                showPay: true,
                                cloneSucess: true,
                                clonedObj: obj,
                            });
                        }

                        // add open record
                        let key = obj.obj;
                        let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                        if (!openTabs.includes(key)) {
                            openTabs.push(key);
                        }
                        this.$store.commit("addWin", newTab);
                        localStorage.setItem("openTabs", JSON.stringify(openTabs));

                        this.doingClone = false;
                        this.$edMessage.destroy();
                        if (!this.vip && !this.pass) {
                            this.sensors.track("tryVipBenefit", {
                                Catalogues: "editFileProcess",
                                trial_vip_benefit: "cummunityVipTemplate",
                            });
                        }
                    })
                    .catch((err) => {
                        let error = err.msg;
                        if (error == "file num over limit") {
                            this.$store.commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: "fileNum",
                            });
                            this.doingClone = false;
                            this.trackData("remindSubscribe");
                            this.$edMessage.destroy();
                        } else if (error == "You do not have enough space.") {
                            if (this.vip) {
                                // 会员
                                if (this.fuser) {
                                    this.$bus.$emit("showCloudSpaceVipTips");
                                } else {
                                    this.$checkAuth({
                                        type: "cloudSpaceVIP",
                                        buyTrigger: "cloudSpacePop",
                                        pcParams: { newUpgrade: 6, upgrade: 0 },
                                    });
                                }
                            } else {
                                this.$checkAuth({
                                    type: "cloudSpace",
                                    buyTrigger: "cloudSpacePop",
                                    pcParams: { newUpgrade: 6, upgrade: 0 },
                                });
                                this.trackData("remindSubscribe");
                            }
                        }
                        newTab && newTab.close();
                    });
            },
            cloneFuncPC() {
                let limitCallback = (type = "") => {
                    this.doingClone = false;
                    if (type == "showLimitModal") {
                        this.$bus.$on("limitModalContinue", () => {
                            console.log("on event");
                            this.$bus.$off("limitModalContinue");
                            this.cloneFuncPC();
                        });
                        this.$store.commit("setState", {
                            type: "showLimitFileModal",
                            data: true,
                        });
                    } else if (type == "showLimitCloudSpaceVIP") {
                        if (this.fuser) {
                            this.$bus.$emit("showCloudSpaceVipTips");
                        } else {
                            this.$checkAuth({
                                type: "cloudSpaceVIP",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        }
                    } else if (type == "showLimitCloudSpace") {
                        this.$checkAuth({
                            type: "cloudSpace",
                            buyTrigger: "cloudSpacePop",
                            pcParams: { newUpgrade: 6, upgrade: 0 },
                        });
                    }
                };
                let checkLimitFunc = (limitCallback) => {
                    return new Promise((rs, rj) => {
                        this.$store.dispatch("getUserLimit", this.$store.state.publicStore.runPlatform).then((res) => {
                            let wmfree = res.data.wmfree_limit;
                            let wmlist = res.data.wmfrees;
                            if (res.data.num >= this.limitFileNum && !this.vip && this.$store.state.limitFileModalFlag) {
                                this.$store.commit("setState", {
                                    type: "limitFileModalFlag",
                                    data: false,
                                });
                                limitCallback && limitCallback("showLimitModal");
                                rj("");
                            } else if (wmfree > 0 && !this.vip) {
                                this.$store.commit("setState", {
                                    type: "limitFileModalFlag",
                                    data: true,
                                });
                                if (wmfree > wmlist.length || wmlist.includes(this.work.id)) {
                                    this.pcFreeTemplateFlag = true;
                                } else {
                                    this.pcFreeTemplateFlag = false;
                                }
                                rs(null);
                            } else if (res.data.is_over_limit) {
                                limitCallback && limitCallback();
                                rj(res.data.is_over_limit);
                            } else if (this.isFullCouldSpace) {
                                if (!this.vip) {
                                    limitCallback && limitCallback("showLimitCloudSpace");
                                } else {
                                    limitCallback && limitCallback("showLimitCloudSpaceVIP");
                                }
                            } else {
                                this.$store.commit("setState", {
                                    type: "limitFileModalFlag",
                                    data: true,
                                });
                                rs(null);
                            }
                        });
                    });
                };
                checkLimitFunc(limitCallback).then(() => {
                    this.pcClone();
                });
            },
            pcClone(work = this.work) {
                if (this.internal) {
                    let { id: workId, path, sign, exp, title: fileName, member_free } = work;
                    //通知pc端clone
                    let callPcAction = (sign, exp, path, checkmfree, imgUrl) => {
                        if (this.internal) {
                            sign = encodeURIComponent(sign);
                        }
                        let param = {
                            id: workId,
                            fileName,
                            sign,
                            exp,
                            obj: path,
                            type: "clone",
                            track: workId + "",
                            imgUrl,
                            accessid: this.OSSAccessKeyId,
                        };
                        if (!this.internal) {
                            param = {
                                id: workId,
                                fileName,
                                query: sign,
                                exp,
                                path,
                                type: "clone",
                                track: workId + "",
                                imgUrl,
                                accessid: this.OSSAccessKeyId,
                            };
                        }
                        if (checkmfree) {
                            param.checkmfree = 1;
                        }
                        if (this.pcFreeTemplateFlag) {
                            param.checkmfree = 0;
                            this.pcFreeTemplateFlag = false;
                        }
                        window.$qt.jsCallCloudFileOperate(JSON.stringify(param));
                        this.trackDataPC("cloneSuccess");
                    };

                    //如果是会员免费，先调接口获取作品源文件下载信息
                    let imgUrl = "";
                    if ((member_free && this.vip) || this.work.user_id == this.userInfo.user_id) {
                        this.$edApi
                            .getWorkDownInfo({
                                id: this.params.id,
                                workId,
                                token: this.params.token,
                            })
                            .then((data) => {
                                sign = data.sign;
                                exp = data.exp;
                                path = data.path;
                                imgUrl = data.url ? `${window["GLOBAL"].PUBLIC_OSS_HOST + data.url}thumb.png` : "noImage";
                                callPcAction(sign, exp, path, true, imgUrl);
                            })
                            .catch((error) => {
                                if (error == "noSpace") {
                                    this.doingClone = false;
                                }
                            });
                    } else if (member_free && !this.vip) {
                        this.$openBuyPage("cummunityVipTemplate");
                    } else {
                        //如果是已购买的，从购买信息中获取sign和exp。如果是免费的就用preItem中的sign和exp
                        if (work.price > 0) {
                            let boughtInfo = this.boughtWorks.find((boughtWork) => {
                                if (boughtWork.work_id == workId) return boughtWork;
                            });

                            sign = boughtInfo.sign;
                            exp = boughtInfo.exp;
                            path = boughtInfo.path;
                            imgUrl = boughtInfo.url ? `${window["GLOBAL"].PUBLIC_OSS_HOST + boughtInfo.url}thumb.png` : "noImage";
                        } else {
                            imgUrl = work.url ? `${window["GLOBAL"].PUBLIC_OSS_HOST + work.url}thumb.png` : "noImage";
                        }
                        callPcAction(sign, exp, path, false, imgUrl);
                    }
                } else {
                    if (!this.$validateLogin()) return;
                    let sendInfoToPc = (key) => {
                        let filePath = key.match(/[^\/]+\/[^\/]+\/(.+)/) && key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                        let fileName = key.match(/[^\/]*(?=\.eddx)/i)[0];
                        let params = Object.assign({ obj: filePath }, this.$store.getters.apiParam);
                        this.$edApi
                            .getDownFileAddress(params)
                            .then((signInfo) => {
                                let obj = key;
                                //中文站用的oss，英文站用的aws，通过getSignature得到的数据不一样
                                let paramForPc;
                                let imgUrl = work.url ? `${window["GLOBAL"].PUBLIC_OSS_HOST + work.url}thumb.png` : "noImage";
                                let { path, query } = signInfo.data;
                                paramForPc = {
                                    fileName: fileName,
                                    path,
                                    query,
                                    type: "open",
                                    from: "template",
                                    imgUrl,
                                    checkmfree: (!this.vip && this.work.member_free) || !this.pass ? 1 : 0,
                                    accessid: this.OSSAccessKeyId,
                                };
                                window.$qt.jsCallCloudFileOperate(JSON.stringify(paramForPc));
                                this.trackDataPC("cloneSuccess");
                            })
                            .catch(() => {
                                this.$store.commit("setPcLockStatus", false);
                                this.$edMessage.warning(this.$t("networkError"));
                            });
                    };

                    if (this.doingClone) return;
                    this.$edMessage.loading({
                        duration: 0,
                        content: this.$t("message.cloning"),
                    });
                    this.doingClone = true;
                    let id = this.params.id,
                        token = this.params.token,
                        workId = work.id;

                    this.$edApi
                        .cloneFile({
                            id,
                            workId,
                            token,
                            member: work.member_free,
                            type: "PC_online",
                            platform: this.$store.state.publicStore.runPlatform,
                        })
                        .then((data) => {
                            let obj = data.object;
                            setTimeout(() => {
                                sendInfoToPc(obj);
                            }, 1500);
                            this.doingClone = false;
                            this.$edMessage.destroy();
                        })
                        .catch((error) => {
                            this.doingClone = false;

                            if (error == "file num over limit") {
                                this.doingClone = false;
                                this.trackDataPC("overLimit");
                                this.$edMessage.destroy();
                            } else if (error == "You do not have enough space.") {
                                this.trackDataPC("spaceLimit");
                                if (this.vip) {
                                    // 会员
                                    this.$edMessage.error(this.$t("noSpaceVip"));
                                    window.$qt.jsCallUpdateUpgradeTrigger && window.$qt.jsCallUpdateUpgradeTrigger("cloudFileSpaceLimit");
                                    window.$qt.jsCallNewUpgradeToPremium && window.$qt.jsCallNewUpgradeToPremium(6);
                                    window.$qt.jsCallUpgradeToPremium && window.$qt.jsCallUpgradeToPremium(3);
                                } else {
                                    this.$store.commit("toPublicStatus", {
                                        type: "showUpgrade",
                                        data: "fileNum",
                                    });
                                }
                            }
                        });
                }
            },

            // clone symbol
            cloneSymbol() {
                if (!this.$validateLogin()) return;
                if (this.isPC) {
                    this.cloneSymbolPC();
                    return;
                }
                let work = this.work;
                if (work.user_id != this.userInfo.user_id && work.price > 0 && this.boughtWorkIds.indexOf(work.id) == -1) {
                    if (EDRAWMAX_USE_CREDIT && this.toCredit()) {
                        return;
                    }
                    // 付费模板，符号模板暂不启用文件限制
                    // let limitFunc = (type = '') => {
                    //     if(type == 'showLimitModal') {
                    //         this.$bus.$on('limitModalContinue', () => {
                    //             console.log('on event')
                    //             this.$bus.$off('limitModalContinue');
                    //             this.cloneSymbol()
                    //         })
                    //         this.$store.commit('setState', {
                    //             type: 'showLimitFileModal',
                    //             data: true
                    //         })
                    //     }
                    // }
                    // this.$openFile({
                    //     params: '',
                    //     fileType: "checkLimit",
                    //     suffix: '',
                    //     checkLimit: true,
                    //     limitRange: "web",
                    //     limitCallback: limitFunc,
                    //     vip: this.vip
                    // }).then(() => {
                    this.$bus.$emit("updatePayPanelStatus", {
                        showPay: true,
                        cloneSucess: false,
                        clonedObj: "",
                    });
                    // })
                    return;
                }
                if (this.doingClone) return;
                this.doingClone = true;

                let wins = this.$store.state.openWinList,
                    targetWin = null;
                if (wins instanceof Array) {
                    targetWin = wins.find((item) => item.name != "");
                    if (targetWin) {
                        this.cloneSymbolFunc("exist", targetWin);
                    } else {
                        this.createNewFile();
                    }
                } else {
                    this.createNewFile();
                }
            },
            cloneSymbolPC() {
                if (!this.$isBiggerVersion("11.5.0")) {
                    this.$Modal.confirm({
                        title: this.$t("tip"),
                        content: this.$t("useSymbolTip"),
                        okText: this.$t("toUpgrade"),
                        cancelText: this.$t("cancelText"),
                        onOk: () => {
                            let updateLink = this.internal
                                ? "https://www.edrawsoft.cn/download-edrawmax.html"
                                : ["en", "zh", "tw"].includes(this.lang)
                                  ? "https://www.edrawsoft.com/download-edrawmax.html"
                                  : `https://www.edrawsoft.com/${this.lang}/download-edrawmax.html`;
                            if (this.isPC) {
                                window.$qt && window.$qt.jsCallOpenUrl && window.$qt.jsCallOpenUrl(updateLink);
                            } else {
                                window.open(updateLink);
                            }
                        },
                        onCancel: () => {},
                    });
                    return;
                }
                let work = this.work;
                if (work.user_id != this.userInfo.user_id && work.price > 0 && this.boughtWorkIds.indexOf(work.id) == -1) {
                    if (EDRAWMAX_USE_CREDIT && this.toCredit()) {
                        return;
                    }
                    // 付费模板，符号模板暂不启用文件限制
                    // let limitFunc = (type = '') => {
                    //     if(type == 'showLimitModal') {
                    //         this.$bus.$on('limitModalContinue', () => {
                    //             console.log('on event')
                    //             this.$bus.$off('limitModalContinue');
                    //             this.cloneSymbol()
                    //         })
                    //         this.$store.commit('setState', {
                    //             type: 'showLimitFileModal',
                    //             data: true
                    //         })
                    //     }
                    // }
                    // this.$openFile({
                    //     params: '',
                    //     fileType: "checkLimit",
                    //     suffix: '',
                    //     checkLimit: true,
                    //     limitRange: "web",
                    //     limitCallback: limitFunc,
                    //     vip: this.vip
                    // }).then(() => {
                    this.$bus.$emit("updatePayPanelStatus", {
                        showPay: true,
                        cloneSucess: false,
                        clonedObj: "",
                    });
                    // })
                    return;
                }
                if (this.doingClone) return;
                this.doingClone = true;

                this.cloneSymbolFunc();
            },

            cloneSymbolFunc(type = "", targetWin, newTab) {
                this.$edMessage.loading({
                    duration: 0,
                    content: this.$t("message.cloning"),
                });
                let id = this.params.id,
                    token = this.params.token,
                    workId = this.work.id;
                if (this.isPC) {
                    // 22/09/19,桌面端克隆符号模板不主动添加到自定义库
                    if (this.work.member_free && !this.vip) {
                        if (window.$qt.jsCallOpenVipTemplateWithoutLogin) {
                            window.$qt.jsCallOpenVipTemplateWithoutLogin(JSON.stringify(this.work));
                        } else {
                            window.$qt.jsCallNewUpgradeToPremium && window.$qt.jsCallNewUpgradeToPremium(4);
                        }
                        window.$qt.jsCallUpgradeToPremium && window.$qt.jsCallUpgradeToPremium(1);
                    } else {
                        this.$edApi
                            .getTemplateDownloadSign({
                                id: this.params.id,
                                token: this.params.token,
                                obj: {
                                    work_id: workId,
                                    platform: this.$store.state.publicStore.runPlatform,
                                },
                            })
                            .then((data) => {
                                let resData = data.data.data;
                                let tbName = this.work.title;
                                let outputData = {
                                    edt: resData.url,
                                    edl: resData.edl_url,
                                    tbName: tbName,
                                    work_id: this.work.id,
                                };
                                window.$qt.jsCallCloudLibraryOperate(JSON.stringify(outputData));
                                this.doingClone = false;
                                this.$edMessage.destroy();
                            })
                            .catch((error) => {
                                if (error == "noSpace") {
                                    this.doingClone = false;
                                }
                            });
                    }
                    return;
                }
                return new Promise((rs, rj) => {
                    this.$openFile({
                        params: {
                            id,
                            workId,
                            token,
                            member: this.work.member_free,
                            type: "online",
                            platform: this.$store.state.publicStore.runPlatform,
                        },
                        fileType: "storeSymbol",
                        suffix: "",
                        checkLimit: false, // this.work.price == 0,
                        limitRange: this.$store.state.publicStore.runPlatform,
                        vip: this.vip,
                        isFullCouldSpace: this.isFullCouldSpace,
                    })
                        .then((obj) => {
                            this.doingClone = false;
                            if (obj.status == "succ") {
                                console.log(obj);
                                this.sensors.track("newFile", {
                                    Catalogues: "openFileProcess",
                                    new_file_type: "templates",
                                });
                                // if(this.isPC) {
                                //     this.cloneSymbolFuncPC(obj).then(e => {
                                //         this.$edMessage.destroy()
                                //     });
                                //     return
                                // }
                                if (type == "exist") {
                                    Object.assign(obj, {
                                        openLibraryWorkID: this.work.id,
                                    });
                                    targetWin.postMessage({ type: "useStoreSymbol", obj }, "*");
                                    setTimeout(() => {
                                        this.$edMessage.destroy();
                                        console.log("focus");
                                        targetWin.focus();
                                    }, 200);
                                } else {
                                    this.$edMessage.destroy();
                                    rs(obj.table_id);
                                }
                            } else {
                                this.$edMessage.destroy();
                                newTab && newTab.close();
                                if (obj.msg == "You do not have enough space.") {
                                    if (!this.vip) {
                                        this.$checkAuth({
                                            type: "cloudSpace",
                                            buyTrigger: "cloudSpacePop",
                                            pcParams: { newUpgrade: 6, upgrade: 0 },
                                        });
                                    } else {
                                        if (this.fuser) {
                                            this.$bus.$emit("showCloudSpaceVipTips");
                                        } else {
                                            this.$checkAuth({
                                                type: "cloudSpaceVIP",
                                                buyTrigger: "cloudSpacePop",
                                                pcParams: { newUpgrade: 6, upgrade: 0 },
                                            });
                                        }
                                    }
                                } else if (obj.msg == "Your subscription is expired") {
                                    // 会员免费符号模板，非会员处理
                                    this.$openBuyPage("cummunityVipTemplate");
                                }
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                });
            },
            cloneSymbolFuncPC(obj) {
                return new Promise((s, j) => {
                    let userInfo = this.userInfo;
                    this.$edApi
                        .getCustomLibraryList({
                            id: userInfo.user_id,
                            token: userInfo.token,
                            type: 0,
                        })
                        .then((e) => {
                            console.log(e.data);
                            let list = e.data;
                            if (list) {
                                let tbName = obj.obj.match(/[^\/]*(?=\.edt)/i)[0];
                                let promiseList = [],
                                    outputData = {
                                        edt: "",
                                        edl: "",
                                        tbName: tbName,
                                        work_id: this.work.id,
                                    };
                                list = list.find((item) => item.table_id == obj.table_id);
                                promiseList.push(
                                    new Promise((rs, rj) => {
                                        this.$edApi
                                            .getCustomKey({
                                                id: userInfo.user_id,
                                                token: userInfo.token,
                                                obj: e.msg + list["name"] + ".edt",
                                            })
                                            .then((e) => {
                                                outputData.edt = window["GLOBAL"].PRIVATE_OSS_HOST + e;
                                                rs();
                                            })
                                            .catch((e) => {
                                                rs("download error");
                                            });
                                    })
                                );
                                promiseList.push(
                                    new Promise((rs, rj) => {
                                        this.$edApi
                                            .getCustomKey({
                                                id: userInfo.user_id,
                                                token: userInfo.token,
                                                obj: e.msg + list["name"] + ".edl",
                                            })
                                            .then((e) => {
                                                outputData.edl = window["GLOBAL"].PRIVATE_OSS_HOST + e;
                                                rs();
                                            })
                                            .catch((e) => {
                                                rs("download error");
                                            });
                                    })
                                );
                                Promise.all(promiseList).then((e) => {
                                    console.log(outputData);
                                    window.$qt.jsCallCloudLibraryOperate(JSON.stringify(outputData));
                                    s();
                                });
                            }
                        });
                });
            },
            createNewFile() {
                let newTab = window.open(`${window.location.origin}${this.$router.options.base}app.html`, "");
                let limitCallback = (type = "") => {
                    newTab && newTab.close();
                    if (type == "showLimitCloudSpaceVIP") {
                        if (this.fuser) {
                            this.$bus.$emit("showCloudSpaceVipTips");
                        } else {
                            this.$checkAuth({
                                type: "cloudSpaceVIP",
                                buyTrigger: "cloudSpacePop",
                                pcParams: { newUpgrade: 6, upgrade: 0 },
                            });
                        }
                    } else if (type == "showLimitCloudSpace") {
                        this.$checkAuth({
                            type: "cloudSpace",
                            buyTrigger: "cloudSpacePop",
                            pcParams: { newUpgrade: 6, upgrade: 0 },
                        });
                    } else {
                        this.$store.commit("toPublicStatus", {
                            type: "showUpgrade",
                            data: "fileNum",
                        });
                    }
                };
                this.cloneSymbolFunc(undefined, undefined, newTab).then((openLibraryID) => {
                    let enterCanvasTrack = `&file_source=emptyFile&template_type=notTemplate&fromNull=1&diagram_type=default`;
                    enterCanvasTrack += openLibraryID ? `&openLibrary=${openLibraryID}&openLibraryWorkID=${this.work.id}` : "";
                    this.$openFile({
                        params: {
                            newFileName: this.$t("newFile"),
                            libs: [373, 14, 4],
                            currentPath: this.nowPrefix,
                            platform: this.$store.state.publicStore.runPlatform,
                        },
                        fileType: "emptyFile",
                        suffix: enterCanvasTrack,
                        checkLimit: false,
                        limitRange: this.$store.state.publicStore.runPlatform,
                        limitCallback: limitCallback,
                        isFullCouldSpace: this.isFullCouldSpace,
                    }).then((obj) => {
                        let url = adonlineURL(obj.url);
                        newTab.location.href = url;
                        this.$store.commit("addWin", newTab);
                        let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                        if (!openTabs.includes(obj.obj)) {
                            openTabs.push(obj.obj);
                        }
                        localStorage.setItem("openTabs", JSON.stringify(openTabs));
                    });
                });
            },

            // track data
            trackData(type) {
                let tType = this.work.price > 0 ? "communityPaid" : this.work.member_free ? "communityVip" : "communityFree";
                let diagramType = "notUseTemplate";
                if (this.$store.state.activeLv3) {
                    diagramType = this.$store.state.activeLv3.lv3name;
                } else if (this.$store.state.activeLv2) {
                    diagramType = this.$store.state.activeLv2.lv2name;
                } else if (this.$store.state.activeLv1) {
                    diagramType = this.$store.state.activeLv1.lv1name;
                }
                switch (type) {
                    case "useTemplate":
                        this.$gaTrack("Template_useCommunityTemplate", `diagramType: ${diagramType}, templateName: ${this.work.title}`);
                        this.sensors.track("useCommunityTemplate", {
                            Catalogues: "Templates",
                            diagram_type: diagramType,
                            template_name: this.work.title,
                            platform: this.isPC ? "desktop" : "online",
                        });
                        this.$gaTrack("openFileProcess_clickTemplates", `templateType: ${tType}}`);
                        break;
                    case "alertVipModal":
                        this.$gaTrack("openFileProcess_useCommunityTemplate", `result: remindSubscribe, templateType: ${tType}}`);
                        this.sensors.track("useCommunityTemplate", {
                            Catalogues: "openFileProcess",
                            result: "remindSubscribe",
                            template_type: tType,
                        });
                        break;
                    case "remindPaid":
                        this.$gaTrack("openFileProcess_useCommunityTemplate", `result: remindPaid, templateType: ${tType}}`);
                        this.sensors.track("useCommunityTemplate", {
                            Catalogues: "openFileProcess",
                            result: "remindPaid",
                            template_type: tType,
                        });
                        break;
                    case "remindSubscribe":
                        this.$gaTrack("openFileProcess_useCommunityTemplate", `result: remindSubscribe, templateType: ${tType}}`);
                        this.sensors.track("useCommunityTemplate", {
                            Catalogues: "openFileProcess",
                            result: "remindSubscribe",
                            template_type: tType,
                        });
                        break;
                    case "cloneSuccess":
                        this.$gaTrack("openFileProcess_useCommunityTemplate", `result: success, templateType: ${tType}}`);
                        this.$gaTrack("openFileProcess_enterCanvas", `fileSource: templateFile, templateType: ${tType}}`);
                        this.sensors.track("useCommunityTemplate", {
                            Catalogues: "openFileProcess",
                            result: "successEnterCanvas",
                            template_type: tType,
                        });
                        this.sensors.track("generateCloudFile", {
                            Catalogues: "openFileProcess",
                            file_source: "templateFile",
                        });
                        this.sensors.track("newFile", {
                            Catalogues: "openFileProcess",
                            new_file_type: "templates",
                        });
                        break;
                    case "":
                        break;
                }
            },
            trackDataPC(type) {
                const trackTemplateWay = this.$store.state.trackTemplateWay;
                let tType = this.work.price > 0 ? "communityPaid" : this.work.member_free ? "communityVip" : "communityFree";
                switch (type) {
                    case "useTemplate":
                        this.$pcTrack(
                            JSON.stringify({
                                type: "Templates",
                                action: "useCommunityTemplate",
                                event: "experience",
                                label: JSON.stringify({
                                    diagram_type: this.trackClass,
                                    template_name: this.work.title,
                                    template_way: trackTemplateWay,
                                }),
                            })
                        );
                        break;
                    case "useVipTemplate":
                        window.$qt.jsCallUpdateUpgradeTrigger && window.$qt.jsCallUpdateUpgradeTrigger("useCummunityVipTemplate");
                        break;
                    case "usePaidTemplate":
                        let templateType = this.work.price > 0 ? "toViewPaidTemplate" : "toViewPaidTemplate";
                        window.$qt.jsCallUpdateLoginTrigger && window.$qt.jsCallUpdateLoginTrigger(templateType);
                        this.$pcTrack(
                            JSON.stringify({
                                type: "openFileProcess",
                                action: "useCommunityTemplate",
                                event: "experience",
                                label: JSON.stringify({
                                    template_type: tType,
                                    template_way: trackTemplateWay,
                                    result: "remindSubscribe",
                                }),
                            })
                        );
                        break;
                    case "remindPaid":
                        this.$gaTrack("openFileProcess_useCommunityTemplate", `result: remindPaid, templateType: ${tType}}`);
                        window.$qt.jsCallUpdateUpgradeTrigger && window.$qt.jsCallUpdateUpgradeTrigger("useVIPTemplate");
                        this.$pcTrack(
                            JSON.stringify({
                                type: "openFileProcess",
                                action: "useCommunityTemplate",
                                event: "experience",
                                label: JSON.stringify({
                                    template_type: tType,
                                    template_way: trackTemplateWay,
                                    result: "remindPaid",
                                }),
                            })
                        );
                        break;
                    case "cloneSuccess":
                        let tType = this.work.price > 0 ? "communityPaid" : this.work.member_free ? "communityVip" : "communityFree";
                        this.$pcTrack(
                            JSON.stringify({
                                type: "openFileProcess",
                                action: "useCommunityTemplate",
                                event: "experience",
                                label: JSON.stringify({
                                    template_type: tType,
                                    template_way: trackTemplateWay,
                                    result: "successEnterCanvas",
                                }),
                            })
                        );
                        this.sensors.track("newFile", {
                            Catalogues: "openFileProcess",
                            new_file_type: "templates",
                        });
                        window.$qt.jsCallUpdateTemplateType && window.$qt.jsCallUpdateTemplateType(tType);
                        break;
                    case "overLimit":
                        window.$qt.jsCallUpdateUpgradeTrigger && window.$qt.jsCallUpdateUpgradeTrigger("cloudFileNumberLimit");
                        window.$qt.jsCallNewUpgradeToPremium && window.$qt.jsCallNewUpgradeToPremium(3);
                        window.$qt.jsCallUpgradeToPremium && window.$qt.jsCallUpgradeToPremium(3);
                        window.$qt.jsCallUploadfailReason && window.$qt.jsCallUploadfailReason("exceedsCloudFileNumber");

                        this.$pcTrack(
                            JSON.stringify({
                                type: "openFileProcess",
                                action: "useCommunityTemplate",
                                event: "experience",
                                label: JSON.stringify({
                                    template_type: tType,
                                    template_way: trackTemplateWay,
                                    result: "remindSubscribe",
                                }),
                            })
                        );
                        break;
                    case "spaceLimit":
                        window.$qt.jsCallUploadfailReason && window.$qt.jsCallUploadfailReason("cloudSpaceLimit");
                        break;
                    case "":
                        break;
                }
            },

            checkFirstVip() {
                if (!EDRAWMAX_PRODUCT_VIPLIMIT) return;
                if (!this.internal) return;
                // console.log('check vipppppppppppppppppfirst')
                this.$edApi
                    .getVipFirst({
                        id: this.params.id,
                        token: this.params.token,
                    })
                    .then((res) => {
                        let status = res.status;
                        if (status == "success") {
                            this.vipFirstFlag = true;
                        } else {
                            if (res.data.used == 0) {
                                this.showVipFirstTip = true;
                            } else {
                                this.showVipFirstTip = false;
                            }
                            this.vipFirstFlag = false;
                        }
                    });
            },
            cloneWorkWithFirstVip() {
                if (!this.internal) return;
                this.$edApi
                    .useVipFirst({
                        id: this.params.id,
                        token: this.params.token,
                        work_id: this.work.id,
                    })
                    .then((flag) => {
                        if (flag) {
                            this.vipFirstFlag = false;
                            this.$store.dispatch("getBoughtWorks").then(() => {
                                this.clone();
                            });
                        }
                    });
            },

            getCredit() {
                if (this.internal) {
                    // 获取抵用金余额
                    this.$edApi
                        .getCredit({
                            id: this.userInfo.user_id,
                            token: this.userInfo.token,
                        })
                        .then((res) => {
                            let data = res.data.data;
                            let v = data && parseFloat(data.surplus) > 0;
                            this.$store.commit("setState", {
                                type: "hasCreditMoney",
                                data: v,
                            });
                        });
                }
            },
            toCredit() {
                if (this.hasCreditMoney) {
                    this.$store.commit("toTplCenter", {
                        name: "showCredit",
                        data: true,
                    });
                }
                return this.hasCreditMoney;
            },
        },
        created() {
            //其他地方手动触发clone事件
            this.$bus.$on("doClone", () => {
                console.log("doClone");
                this.clone();
            });
            this.$bus.$on("loginSucc-preview", () => {
                let cloneVipTips = JSON.parse(localStorage.getItem("cloneVipTips"));
                this.cloneVipTips = !(cloneVipTips && cloneVipTips.includes(this.userInfo.user_id));
                console.log("cloneVipTips---", this.cloneVipTips);
                this.checkFirstVip();
                this.getCredit();
            });
            this.$bus.$on("checkVipFirst", () => {
                this.checkFirstVip();
            });
            window.addEventListener("resize", this.resizeEvent);
            window.addEventListener("keydown", this.togglePreEvent);

            // window.addEventListener('DOMMouseScroll', zoomFunc, { passive: false }); //firefox;
            // window.addEventListener('wheel', zoomFunc, { passive: false });//IE/Opera/Chrome/Safari
        },
        mounted() {
            if (this.userInfo) {
                if (!this.params.islogin) {
                    return;
                }
                let cloneVipTips = JSON.parse(localStorage.getItem("cloneVipTips"));
                this.cloneVipTips = !(cloneVipTips && cloneVipTips.includes(this.userInfo.user_id));
                console.log("cloneVipTips---", this.cloneVipTips);
                this.checkFirstVip();
                this.getCredit();
            }
            this.$bus.$on("paySymbolCallback", (status) => {
                if (status == "success") {
                    this.cloneSymbol();
                }
            });
            this.$bus.$on("pcCloneEvent", (work) => {
                if (Object.prototype.toString.call(work) === "[object String]") {
                    work = JSON.parse(work);
                }
                if (work.id != this.work.id) {
                    return;
                } else {
                    this.pcClone(work);
                }
            });
            this.$bus.$on("firstCloneFreeBusToClone", (type) => {
                if (type == "toVip") {
                    this.firstCloneFreeToVip();
                } else if (type == "clone") {
                    this.clone();
                } else if (type == "toUse") {
                    this.cloneWorkWithFirstVip();
                }
            });
        },
        beforeDestroy() {
            this.$bus.$off("doClone");
            this.$bus.$off("loginSucc-preview");
            this.$bus.$off("checkVipFirst");
            this.$bus.$off("paySymbolCallback");
            this.$bus.$off("pcCloneEvent");
            this.$bus.$off("firstCloneFreeBusToClone");
        },
    };
</script>
